import { useContext, useEffect } from "react"
import LandingMobile from "../../components/landing/LandingMobile"
import { MainContext } from "../../controllers/main"
import LandingDesktop from "../../components/landing/LandingDesktop"
import { registerPageEvent } from "../../services/utils/utils"
import LandingDesktopRecap from "../../components/landing/LandingDesktopRecap"

const Landing = () => {
  const { isMobile, isChallengeOver } = useContext(MainContext)

  // register google analytics event
  useEffect(() => {
    registerPageEvent("landing")
  }, [])

  return isMobile ? (
    <LandingMobile />
  ) : isChallengeOver ? (
    <LandingDesktopRecap />
  ) : (
    <LandingDesktop />
  )
}

export default Landing
